import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import type { Mapping } from '@/schemas/API/GET/mapping/response';

const useEmpTimeMapping = () => {
  const { data: empTimeMap } = useSWR<Mapping>(
    'mappings/employment-times',
    getFetcher
  );

  return empTimeMap;
};

export default useEmpTimeMapping;
